export default [
  {
    name: 'alterar-senha-interno',
    path: '/alterar-senha-interno',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/app-modulo/documento/alterar-senha-interno/AlterarSenhaInterno.vue'),
    meta: {
      resource: 'alterarsenhainterno',
      action: 'auditar',
      requiredAuth: false,
      layout: 'full',
    },
  },
]
